import { render } from "./ChangeStoragePoolScope.vue?vue&type=template&id=196e1a2c"
import script from "./ChangeStoragePoolScope.vue?vue&type=script&lang=js"
export * from "./ChangeStoragePoolScope.vue?vue&type=script&lang=js"

import "./ChangeStoragePoolScope.vue?vue&type=style&index=0&id=196e1a2c&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__